import {
  Tag,
  TagBlockProps,
} from 'libs/growth-platform-brand-system-v2/src/components/Tag';
import { textBodySmall } from 'libs/growth-platform-brand-system-v2/src/styles/typography';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { findStringInReactNode } from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import {
  StructuredText as IStructuredText,
  isLink,
  isParagraph,
} from 'datocms-structured-text-utils';
import React from 'react';
import { StructuredText, renderRule } from 'react-datocms';
import Nop from '../../../images/nop.svg';
import { useBanner } from 'apps/website/src/utils/useBanner';

interface IBanner {
  tag?: TagBlockProps;
  text: IStructuredText;
  minimalText: IStructuredText;
  bannerClose: any;
  locale: 'es' | 'fr' | 'en';
}

const TextBanner = ({ text }: any) => {
  return (
    <StructuredText
      data={text}
      customNodeRules={[
        renderRule(isParagraph, ({ children, key }) => (
          <p
            key={key}
            className={classNames(textBodySmall, 'header-banner-text')}
          >
            {children}
          </p>
        )),
        renderRule(isLink, ({ node, children, key }) => {
          return (
            <ButtonTracking
              labelTracking={findStringInReactNode(children)}
              component={'a'}
              section="Banner"
              index={key}
              href={node.url}
              key={key}
            >
              {children}
            </ButtonTracking>
          );
        }),
      ]}
    />
  );
};

const translateCloseBtn = {
  en: 'Close banner',
  fr: 'Fermer la bannière',
  es: 'Cerrar banner',
};
export const Banner = ({ tag, text, minimalText, locale }: IBanner) => {
  const { bannerVisible, bannerClose } = useBanner();

  if (!bannerVisible) return null;
  return (
    <div className={classNames('Banner container flex justify-center')}>
      <div className="flex items-center gap-16 py-16 bg-neutral-1">
        {tag && (
          <Tag {...tag} size="small">
            {tag.title}
          </Tag>
        )}
        {text && (
          <div className="hidden md:block">
            <TextBanner text={text} />
          </div>
        )}
        {minimalText && (
          <div className="block md:hidden">
            <TextBanner text={minimalText} />
          </div>
        )}
        <button
          className="min-w-20 w-20 h-20 cursor-pointer"
          style={{ padding: '6px' }}
          aria-label={translateCloseBtn[locale]}
          onClick={() => bannerClose()}
        >
          <Nop className="w-full h-full" />
        </button>
      </div>
    </div>
  );
};
